function cov_v5m9svdge() {
  var path = "/__w/code/code/js/packages/cinderblocks/src/helpers/globals.ts";
  var hash = "6838817625fe1a0e9ab8122b63315d4f15f3058e";
  var global = new Function("return this")();
  var gcv = "__coverage__";
  var coverageData = {
    path: "/__w/code/code/js/packages/cinderblocks/src/helpers/globals.ts",
    statementMap: {
      "0": {
        start: {
          line: 4,
          column: 17
        },
        end: {
          line: 4,
          column: 30
        }
      },
      "1": {
        start: {
          line: 5,
          column: 16
        },
        end: {
          line: 5,
          column: 39
        }
      },
      "2": {
        start: {
          line: 7,
          column: 32
        },
        end: {
          line: 7,
          column: 54
        }
      },
      "3": {
        start: {
          line: 8,
          column: 31
        },
        end: {
          line: 8,
          column: 49
        }
      },
      "4": {
        start: {
          line: 10,
          column: 33
        },
        end: {
          line: 10,
          column: 57
        }
      },
      "5": {
        start: {
          line: 23,
          column: 28
        },
        end: {
          line: 41,
          column: 1
        }
      },
      "6": {
        start: {
          line: 25,
          column: 2
        },
        end: {
          line: 27,
          column: 3
        }
      },
      "7": {
        start: {
          line: 26,
          column: 4
        },
        end: {
          line: 26,
          column: 72
        }
      },
      "8": {
        start: {
          line: 30,
          column: 2
        },
        end: {
          line: 32,
          column: 3
        }
      },
      "9": {
        start: {
          line: 31,
          column: 4
        },
        end: {
          line: 31,
          column: 76
        }
      },
      "10": {
        start: {
          line: 35,
          column: 2
        },
        end: {
          line: 37,
          column: 3
        }
      },
      "11": {
        start: {
          line: 36,
          column: 4
        },
        end: {
          line: 36,
          column: 64
        }
      },
      "12": {
        start: {
          line: 40,
          column: 2
        },
        end: {
          line: 40,
          column: 23
        }
      },
      "13": {
        start: {
          line: 46,
          column: 31
        },
        end: {
          line: 48,
          column: 1
        }
      },
      "14": {
        start: {
          line: 47,
          column: 2
        },
        end: {
          line: 47,
          column: 41
        }
      },
      "15": {
        start: {
          line: 53,
          column: 32
        },
        end: {
          line: 55,
          column: 1
        }
      },
      "16": {
        start: {
          line: 54,
          column: 2
        },
        end: {
          line: 54,
          column: 42
        }
      }
    },
    fnMap: {
      "0": {
        name: "(anonymous_0)",
        decl: {
          start: {
            line: 23,
            column: 28
          },
          end: {
            line: 23,
            column: 29
          }
        },
        loc: {
          start: {
            line: 23,
            column: 62
          },
          end: {
            line: 41,
            column: 1
          }
        },
        line: 23
      },
      "1": {
        name: "(anonymous_1)",
        decl: {
          start: {
            line: 46,
            column: 31
          },
          end: {
            line: 46,
            column: 32
          }
        },
        loc: {
          start: {
            line: 46,
            column: 46
          },
          end: {
            line: 48,
            column: 1
          }
        },
        line: 46
      },
      "2": {
        name: "(anonymous_2)",
        decl: {
          start: {
            line: 53,
            column: 32
          },
          end: {
            line: 53,
            column: 33
          }
        },
        loc: {
          start: {
            line: 53,
            column: 47
          },
          end: {
            line: 55,
            column: 1
          }
        },
        line: 53
      }
    },
    branchMap: {
      "0": {
        loc: {
          start: {
            line: 25,
            column: 2
          },
          end: {
            line: 27,
            column: 3
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 25,
            column: 2
          },
          end: {
            line: 27,
            column: 3
          }
        }, {
          start: {
            line: undefined,
            column: undefined
          },
          end: {
            line: undefined,
            column: undefined
          }
        }],
        line: 25
      },
      "1": {
        loc: {
          start: {
            line: 25,
            column: 6
          },
          end: {
            line: 25,
            column: 70
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 25,
            column: 6
          },
          end: {
            line: 25,
            column: 35
          }
        }, {
          start: {
            line: 25,
            column: 39
          },
          end: {
            line: 25,
            column: 70
          }
        }],
        line: 25
      },
      "2": {
        loc: {
          start: {
            line: 30,
            column: 2
          },
          end: {
            line: 32,
            column: 3
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 30,
            column: 2
          },
          end: {
            line: 32,
            column: 3
          }
        }, {
          start: {
            line: undefined,
            column: undefined
          },
          end: {
            line: undefined,
            column: undefined
          }
        }],
        line: 30
      },
      "3": {
        loc: {
          start: {
            line: 30,
            column: 6
          },
          end: {
            line: 30,
            column: 75
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 30,
            column: 6
          },
          end: {
            line: 30,
            column: 36
          }
        }, {
          start: {
            line: 30,
            column: 40
          },
          end: {
            line: 30,
            column: 75
          }
        }],
        line: 30
      },
      "4": {
        loc: {
          start: {
            line: 35,
            column: 2
          },
          end: {
            line: 37,
            column: 3
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 35,
            column: 2
          },
          end: {
            line: 37,
            column: 3
          }
        }, {
          start: {
            line: undefined,
            column: undefined
          },
          end: {
            line: undefined,
            column: undefined
          }
        }],
        line: 35
      },
      "5": {
        loc: {
          start: {
            line: 35,
            column: 6
          },
          end: {
            line: 35,
            column: 63
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 35,
            column: 6
          },
          end: {
            line: 35,
            column: 36
          }
        }, {
          start: {
            line: 35,
            column: 40
          },
          end: {
            line: 35,
            column: 63
          }
        }],
        line: 35
      }
    },
    s: {
      "0": 0,
      "1": 0,
      "2": 0,
      "3": 0,
      "4": 0,
      "5": 0,
      "6": 0,
      "7": 0,
      "8": 0,
      "9": 0,
      "10": 0,
      "11": 0,
      "12": 0,
      "13": 0,
      "14": 0,
      "15": 0,
      "16": 0
    },
    f: {
      "0": 0,
      "1": 0,
      "2": 0
    },
    b: {
      "0": [0, 0],
      "1": [0, 0],
      "2": [0, 0],
      "3": [0, 0],
      "4": [0, 0],
      "5": [0, 0]
    },
    _coverageSchema: "1a1c01bbd47fc00a2c39e90264f33305004495a9",
    hash: "6838817625fe1a0e9ab8122b63315d4f15f3058e"
  };
  var coverage = global[gcv] || (global[gcv] = {});
  if (!coverage[path] || coverage[path].hash !== hash) {
    coverage[path] = coverageData;
  }
  var actualCoverage = coverage[path];
  {
    // @ts-ignore
    cov_v5m9svdge = function () {
      return actualCoverage;
    };
  }
  return actualCoverage;
}
cov_v5m9svdge();
import commonGlobals from '@opendoor/shared-fe/commonGlobals';
import { getRailsEnv } from '@opendoor/shared-fe/railsEnv';
var railsEnv = (cov_v5m9svdge().s[0]++, getRailsEnv());
var secrets = (cov_v5m9svdge().s[1]++, commonGlobals[railsEnv]);
export var GOOGLE_CLIENT_ID = (cov_v5m9svdge().s[2]++, secrets.googleClientID);
export var GOOGLE_MAPS_KEY = (cov_v5m9svdge().s[3]++, secrets.googleMaps);
export var SUPPORTED_LOCALES = (cov_v5m9svdge().s[4]++, ['en-US', 'es']);
/**
 * Gets the current environment in a framework-agnostic way.
 * Works with Next.js (Cosmos), Remix (Cake), and browser contexts.
 *
 * Priority order:
 * 1. window.ENV?.DEPLOY_ENV (Remix client-side)
 * 2. process.env.NEXT_PUBLIC_DEPLOY_ENV (Next.js client & server)
 * 3. process.env.DEPLOY_ENV (Remix server-side)
 * 4. getRailsEnv() (Fallback to hostname detection)
 */
cov_v5m9svdge().s[5]++;
export var getDeployEnv = function getDeployEnv() {
  var _ENV, _process$env, _process$env2;
  cov_v5m9svdge().f[0]++;
  cov_v5m9svdge().s[6]++;
  // Check window.ENV first (Remix pattern)
  if ((cov_v5m9svdge().b[1][0]++, typeof window !== 'undefined') && (cov_v5m9svdge().b[1][1]++, (_ENV = window.ENV) !== null && _ENV !== void 0 && _ENV.DEPLOY_ENV)) {
    cov_v5m9svdge().b[0][0]++;
    cov_v5m9svdge().s[7]++;
    return window.ENV.DEPLOY_ENV;
  } else {
    cov_v5m9svdge().b[0][1]++;
  }

  // Check Next.js public env var
  cov_v5m9svdge().s[8]++;
  if ((cov_v5m9svdge().b[3][0]++, typeof process !== 'undefined') && (cov_v5m9svdge().b[3][1]++, (_process$env = process.env) !== null && _process$env !== void 0 && _process$env.NEXT_PUBLIC_DEPLOY_ENV)) {
    cov_v5m9svdge().b[2][0]++;
    cov_v5m9svdge().s[9]++;
    return process.env.NEXT_PUBLIC_DEPLOY_ENV;
  } else {
    cov_v5m9svdge().b[2][1]++;
  }

  // Check Remix server env var
  cov_v5m9svdge().s[10]++;
  if ((cov_v5m9svdge().b[5][0]++, typeof process !== 'undefined') && (cov_v5m9svdge().b[5][1]++, (_process$env2 = process.env) !== null && _process$env2 !== void 0 && _process$env2.DEPLOY_ENV)) {
    cov_v5m9svdge().b[4][0]++;
    cov_v5m9svdge().s[11]++;
    return process.env.DEPLOY_ENV;
  } else {
    cov_v5m9svdge().b[4][1]++;
  }

  // Falls back to Rails env method in shared-fe
  cov_v5m9svdge().s[12]++;
  return getRailsEnv();
};

/**
 * Checks if the current deploy environment is production.
 */
cov_v5m9svdge().s[13]++;
export var isProductionEnv = function isProductionEnv() {
  cov_v5m9svdge().f[1]++;
  cov_v5m9svdge().s[14]++;
  return getDeployEnv() === 'production';
};

/**
 * Checks if the current deploy environment is development.
 */
cov_v5m9svdge().s[15]++;
export var isDevelopmentEnv = function isDevelopmentEnv() {
  cov_v5m9svdge().f[2]++;
  cov_v5m9svdge().s[16]++;
  return getDeployEnv() === 'development';
};
//# sourceMappingURL=globals.mjs.map